var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetryIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.125 10.9375L65.625 23.964L53.125 36.9792",
    stroke: "#222222",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3647 24.0186L50.0348 24.0186C31.612 24.0024 16.6667 38.9314 16.6667 57.3342C16.6667 75.737 31.612 90.666 50.0348 90.666C68.4576 90.666 83.4029 75.737 83.4029 57.3342",
    stroke: "#222222",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2415 47.917C39.7469 48.5842 40.3999 49.1253 41.1495 49.4979C41.899 49.8704 42.7247 50.0643 43.5617 50.0643C44.3988 50.0643 45.2244 49.8704 45.974 49.4979C46.7235 49.1253 47.3766 48.5842 47.882 47.917",
    stroke: "#222222",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0728 47.917C54.5782 48.5842 55.2312 49.1253 55.9808 49.4979C56.7303 49.8704 57.556 50.0643 58.393 50.0643C59.2301 50.0643 60.0557 49.8704 60.8053 49.4979C61.5548 49.1253 62.2079 48.5842 62.7133 47.917",
    stroke: "#222222",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8919 64.9744C61.4981 63.1343 59.6969 61.6421 57.6298 60.6148C55.5626 59.5874 53.2856 59.0527 50.9772 59.0527C48.6688 59.0527 46.3918 59.5874 44.3247 60.6148C42.2575 61.6421 40.4564 63.1343 39.0625 64.9744",
    stroke: "#222222",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetryIllustration);
export default __webpack_public_path__ + "static/media/retry-illustration.35bb3a69.svg";
export { ForwardRef as ReactComponent };